import React, { useState, useEffect } from 'react';
import {
    Card,
    CardHeader,
    CardBody,
    Button,
    Spinner
} from 'reactstrap';
import MaterialTable from 'material-table';
import moment from 'moment';

// Constants
import { table_translate, table_style } from "../../../constants/MaterialTable.js";

// Components
import AdicionarContrato from './AdicionarContrato.jsx';
import FichaContrato from './FichaContrato.jsx';

// Api
import contrato_api from '../../../api/contrato_api.js';

// Helpers
import { showMessage } from '../../../helpers/message.js';


export default function Contratos() {
    //Estado de controle do loading na tela
    const [show_loading, set_show_loading] = useState(false);

    //Estado de controle da tela de adição
    const [adicionar, set_adicionar] = useState(false);

    //Estado de controle da tela de ficha
    const [ficha, set_ficha] = useState(null);

    //Estado de controle da lista da tabela
    const [list_table, set_list_table] = useState([]);

    //Função de clique do botão de visualizar
    const handleVisualizar = (rowData) => {
        console.log(rowData)
        set_ficha(rowData.contrato_Id);
    }

    //Função de voltar das telas de adicionar e ficha
    const handleVoltar = () => {
        set_adicionar(false);
        set_ficha(null);
    }

    //Função que carrega a lista de contratos
    const loadContratos = () => {
        set_show_loading(true);
        contrato_api.getAll().then(response => {
            if (response.status !== 200) {
                showMessage("Aviso", response.message, 'error', null);
                return;
            }
            response.data = response.data.map(value => {
                value.emissao = moment(value.emissao).format("DD/MM/YYYY");
                value.inicioVigencia = moment(value.inicioVigencia).format("DD/MM/YYYY");
                value.fimVigencia = moment(value.fimVigencia).format("DD/MM/YYYY");
                return value;
            })
            set_list_table(response.data);
        }).finally(f => set_show_loading(false))
    }

    useEffect(() => {
        loadContratos();
    }, []);
    if (adicionar) {
        return <AdicionarContrato btnVoltar={handleVoltar} />
    }
    if (ficha) {
        return <FichaContrato btnVoltar={handleVoltar} id={ficha} />
    }
    return (
        <div className={"content"}>
            {show_loading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <Card>
                <CardHeader className="d-flex align-items-center justify-content-between">
                    <h4 className="titleCard mb-0">Lista de Contratos</h4>
                    <Button color={"success"} onClick={() => set_adicionar(true)}>+ Adicionar</Button>
                </CardHeader>
                <CardBody>
                    <MaterialTable style={{ minHeight: "auto" }}
                        title=""
                        columns={[
                            { title: 'Número Processo', field: 'numeroProcesso' },
                            { title: 'Identificação', field: 'identificacao' },
                            { title: 'Emissão', field: 'emissao' },
                            { title: 'Início Vigência', field: 'inicioVigencia' },
                            { title: 'Fim Vigência', field: 'fimVigencia' },
                        ]}
                        data={list_table}
                        isLoading={false}
                        options={{
                            ...table_style,
                            filtering: false,
                            exportButton: true
                        }}
                        actions={[
                            {
                                icon: 'search',
                                tooltip: 'Visualizar Registro',
                                onClick: (event, rowData) => handleVisualizar(rowData)
                            }
                        ]}
                        localization={table_translate}
                    />
                </CardBody>
            </Card>
        </div >
    )
}